import React from 'react';
import PropTypes from 'prop-types';

class LoadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      image: null
    };
  }

  load(url) {
    const onLoad = () => {
      this.setState({ isLoading: false, image: this.image });
    };
    this.setState({ isLoading: true });
    this.image = new Image();
    this.image.onload = onLoad;
    this.image.onerror = onLoad;
    this.image.src = url;
  }

  componentDidMount() {
    this.load(this.props.url);
  }

  componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      this.load(this.props.url);
    }
  }

  componentWillUnmount() {
    this.image.onload = null;
    this.image.onerror = null;
  }

  render() {
    return this.props.children(this.state);
  }
}

LoadImage.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired
};

export default LoadImage;
